import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../Layout";
import { fetchRequest } from "../../store/cardType/actions";
import { ApplicationState } from "../../store";
import CardTypeTable from "./cardTypeTable/CardTypeTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";

export default function CardType() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();

  useEffect(() => {
    dispatch(fetchRequest(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.cardType
  );
  const cardTypes = data?.data || [];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity="CardType"
                  heading="CardTypes Management"
                  primaryButtonText="Add new CardType"
                  primaryButtonClickHandler={() => history.push("/cardType/new")}
                />
              </Paper>
              <Box my={2}>
                <Paper>
                  {loading ? (
                    <ProgressIndicator />
                  ) : (
                    <>
                      <CardTypeTable cardTypeData={cardTypes} />
                    </>
                  )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
